let language = {
    CRAFT_SHOP_ORDER_ITEMS_LIST_STATUS: "状态",
    CRAFT_SHOP_ORDER_ITEMS_LIST_STATUS_AWAITING_IMPORT: "等待导入",
    CRAFT_SHOP_ORDER_ITEMS_LIST_STATUS_INVALID_DATA: "数据无效",
    CRAFT_SHOP_ORDER_ITEMS_LIST_STATUS_IMPORT_FAILED: "导入失败",
    CRAFT_SHOP_ORDER_ITEMS_LIST_STATUS_IMPORT_COMPLETE: "导入完成",
    CRAFT_SHOP_ORDER_ITEMS_LIST_STATUS_VERIFICATION_SUCCESS: "部分导入成功",
    CRAFT_SHOP_ORDER_ITEMS_LIST_IMPORT_FILE: "导入文件",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ORDER_NO: "订单号",
    CRAFT_SHOP_ORDER_ITEMS_LIST_PRODUCT_ID: "产品ID",
    CRAFT_SHOP_ORDER_ITEMS_LIST_QUANTITY: "数量",
    CRAFT_SHOP_ORDER_ITEMS_LIST_OPERATION: "操作",
    // 未知错误
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500006: "一个或多个字段缺少或输入不正确，请在订单页面编辑订单并重试。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500007: "一个或多个字段缺少或输入不正确，请在订单页面编辑订单并重试。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500008: "无效的电子邮件地址",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500009: "无效的数量（必须大于{{moq}}）",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500010: "店铺产品不存在，请检查您的产品SKU。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500011: "订单已成功导入并已完成，无法对详情进行进一步更改。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500013: "订单中检测到重复的店铺产品。请更新同一订单中重复项目的数量以继续。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500014: "无效的国家/地区。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500015: "店铺产品不存在。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500016: "重复的订单号。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500017: "店铺产品未激活，请在我的产品页面激活产品。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500018: "该产品不属于当前店铺。请确保您尝试订购的商品属于活动店铺产品目录。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500019: "店铺中的产品配置不正确。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500020: "店铺产品定价配置不正确。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500021: "该订单已成功导入，但订单中的一项或多项未能导入。请查看详情并重试。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500022: "货币转换失败，如果问题持续，请联系我们 {{email}}。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500024: "地址检查失败",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500025: "省份错误",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500012: "电话号码错误",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000061: "必填字段。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000071: "字段类型错误。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000081: "无效的电子邮件地址。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000091: "无效的数量（必须大于{{moq}}）。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000101: "店铺产品不存在，请检查您的产品SKU",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000111: "订单已成功导入并已完成，无法对详情进行进一步更改。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000131: "订单中检测到重复的店铺产品。请更新同一订单中重复项目的数量以继续。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000141: "无效的国家/地区。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000151: "店铺产品不存在。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000161: "重复的订单号。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000171: "店铺产品未激活，请在我的产品页面激活产品。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000181: "该产品不属于当前店铺。请确保您尝试订购的商品属于活动店铺产品目录。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000191: "店铺中的产品配置不正确。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000201: "店铺产品定价配置不正确。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000211: "该订单已成功导入，但订单中的一项或多项未能导入。请查看详情并重试。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000221: "货币转换失败，如果问题持续，请联系我们 {{email}}。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000241: "地址检查失败",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000251: "省份错误",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000121: "电话号码错误",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_UNKNOWN_ERROR: "未知错误。",

    CRAFT_SHOP_ORDER_ITEMS_LIST_EDIT_ORDER: "编辑订单",
    CRAFT_SHOP_ORDER_ITEMS_LIST_CREATE_NEW_ORDER: "创建新订单",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ORDER_INFORMATION: "订单信息：",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ORDER_NUMBER: "订单号：",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ORDER_NUMBER_REQUIRED: "订单号是必填项",
    CRAFT_SHOP_ORDER_ITEMS_LIST_DELIVERY_ADDRESS: "配送地址：",
    CRAFT_SHOP_ORDER_ITEMS_LIST_FIRST_NAME: "名字：",
    CRAFT_SHOP_ORDER_ITEMS_LIST_FIRST_NAME_REQUIRED: "名字是必填项。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_LAST_NAME: "姓氏：",
    CRAFT_SHOP_ORDER_ITEMS_LIST_LAST_NAME_REQUIRED: "姓氏是必填项。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_COUNTRY_REGION: "国家/地区：",
    CRAFT_SHOP_ORDER_ITEMS_LIST_COUNTRY_REQUIRED: "国家是必填项。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_EMAIL_ADDRESS: "电子邮件地址：",
    CRAFT_SHOP_ORDER_ITEMS_LIST_EMAIL_INVALID: "无效的电子邮件地址",
    CRAFT_SHOP_ORDER_ITEMS_LIST_EMAIL_REQUIRED: "电子邮件地址是必填项。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_STATE_PROVINCE: "省/州：",
    CRAFT_SHOP_ORDER_ITEMS_LIST_STATE_REQUIRED: "省/州是必填项。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_PHONE_NUMBER_1: "电话号码1：",
    CRAFT_SHOP_ORDER_ITEMS_LIST_PHONE_NUMBER_INVALID: "请输入有效的电话号码。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_PHONE_NUMBER_REQUIRED: "请输入电话号码。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_CITY_TOWN: "城市/城镇：",
    CRAFT_SHOP_ORDER_ITEMS_LIST_CITY_REQUIRED: "城市是必填项。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_POSTAL_CODE: "邮政编码：",
    CRAFT_SHOP_ORDER_ITEMS_LIST_POSTAL_CODE_REQUIRED: "邮政编码是必填项。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_POSTAL_CODE_INVALID: "请输入有效的邮政编码。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ADDRESS_1: "地址1：",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ADDRESS_1_REQUIRED: "地址1是必填项。",
    CRAFT_SHOP_ORDER_ITEMS_LIST_PRODUCT_ITEM: "产品项目",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ADD_PRODUCT: "添加产品",
    CRAFT_SHOP_ORDER_ITEMS_LIST_PRODUCT_ID_MODEL: "产品ID",
    CRAFT_SHOP_ORDER_ITEMS_LIST_QUANTITY_MODEL: "数量",
    CRAFT_SHOP_ORDER_ITEMS_LIST_UNIT_PRICE: "单价",
    CRAFT_SHOP_ORDER_ITEMS_LIST_SUBTOTAL: "小计",
    CRAFT_SHOP_ORDER_ITEMS_LIST_CANCEL: "取消",
    CRAFT_SHOP_ORDER_ITEMS_LIST_SAVE: "保存",
    CRAFT_SHOP_ORDER_ITEMS_LIST_DELETE: "删除",
    CRAFT_SHOP_ORDER_ITEMS_LIST_DELETE_HINT_TITLE: "删除确认",
    CRAFT_SHOP_ORDER_ITEMS_LIST_DELETE_HINT_CONTENT: "此操作将永久删除所有订单数据，包括导入的项目。您确定要继续吗？",
    CRAFT_SHOP_ORDER_ITEMS_LIST_DELETE_HINT_CONTENT1: "您确定要删除吗？",
    CRAFT_SHOP_ORDER_ITEMS_REVISE_THE_QUANTITY: "修改数量",
    CRAFT_SHOP_ORDER_ITEMS_QUANTITY: "数量",
    CRAFT_SHOP_ORDER_ITEMS_SAVE_REEOR_TITLE: "编辑错误",
    CRAFT_SHOP_ORDER_ITEMS_SAVE_REEOR_CONTENT: "订单项不能为空",
    CRAFT_SHOP_ORDER_ITEMS_SAVE_REEOR_CONTENT_1500014: "检查地址超时",
};
export { language }